import React from "react";
import { Modal, ModalBody, Button, FormGroup } from "reactstrap";
import { useVendor } from "../Store/VendorStore";
import { sendBookingMessage } from "../Store/BookingApi";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Spinner from "react-bootstrap/Spinner";
import Swal from "sweetalert2"; // ✅ Import SweetAlert2
import "../Assets/modals.css";

const BookVendorModal = ({ isOpen, toggle }) => {
  const { vendorData } = useVendor();

  // Validation schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .min(1, "Name must be at least 2 characters"),
    contact: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  // Handle form submission
  const handleFormSubmit = async (values, { setSubmitting }) => {
    const payload = {
      vendor_profile_Id: vendorData.id,
      name: values.name,
      contact_info: values.contact,
      message: values.message,
    };

    try {
      const response = await sendBookingMessage(payload);

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: response.message || "Your message has been sent successfully.",
          confirmButtonColor: "#3C3C3C",
          zIndex: 10000,
          showConfirmButton: false,
        });
        toggle();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message || "Failed to send message",
          confirmButtonColor: "#3C3C3C",
          zIndex: 10000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error sending message:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again later.",
        confirmButtonColor: "#3C3C3C",
        zIndex: 10000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={toggle}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "2rem",
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "20px",
          }}
        >
          &times;
        </button>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ padding: "10px 41px" }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ margin: "20px auto", flexDirection: "column" }}
          >
            <img
              style={{
                borderRadius: "50%",
                height: "200px",
                width: "200px",
                display: "block",
              }}
              src={
                vendorData?.Profile_Image?.url ||
                "https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2264922221.jpg"
              }
              alt="Vendor Profile"
            />
            <h2 className="Pheading" style={{ fontWeight: "700" }}>
              {vendorData.Name || "Vendor Name"}
            </h2>
            
            <h5
              style={{
                fontWeight: "700",
                marginTop: "20px",
                fontSize: "1.2rem",
              }}
            >
              BOOK THIS VENDOR
            </h5>
            <h6
              className="text-start"
              style={{ fontWeight: "400", marginTop: "20px" }}
            >
              Send this vendor a quick message to book them for an upcoming
              event or a special order.
            </h6>
          </div>
        </div>

        <ModalBody style={{ padding: "10px 41px" }}>
          <Formik
            initialValues={{
              name: "",
              contact: "",
              message: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Field
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Name"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    style={{ color: "red" }}
                  />
                </FormGroup>

                <FormGroup>
                  <Field
                    type="text"
                    name="contact"
                    id="contact"
                    placeholder="Email"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="contact"
                    component="div"
                    style={{ color: "red" }}
                  />
                </FormGroup>

                <FormGroup>
                  <Field
                    as="textarea"
                    name="message"
                    id="message"
                    placeholder="Some message to the vendor..."
                    className="form-control"
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    style={{ color: "red" }}
                  />
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "40px",
                  }}
                >
                  <Button
                    color="primary"
                    className="BookingSubmitButton"
                    style={{
                      background: "#3C3C3C",
                    }}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner
                          animation="border"
                          variant="light"
                          size="sm"
                          style={{ marginRight: "5px" }}
                        />
                        Sending...
                      </>
                    ) : (
                      "SEND BOOK ME MESSAGE"
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </>
  );
};

export default BookVendorModal;
